import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-multiselect',
  templateUrl: './multiselect.component.html',
  styleUrls: ['./multiselect.component.css']
})
export class MultiselectComponent implements OnInit, OnDestroy{
  @Input() items = [];
  @Input() label = '';
  @Output() selectedItems = new EventEmitter<any[]>();
  @Output() selectedNames = new EventEmitter<string[]>();
  @Output() selectedItemDetails = new EventEmitter<any[]>();

  control = new FormControl();
  allSelected = false;

  ngOnInit() {
    this.control.valueChanges.subscribe((value) => {
      if (value) {  // Agregado el chequeo de null
        this.selectedItems.emit(value);
        const names = this.items.filter(item => value.includes(item.id)).map(item => item.name);
        this.selectedNames.emit(names);
  
        const details = this.items.filter(item => value.includes(item.id));
        this.selectedItemDetails.emit(details);
      } else {
        this.selectedItems.emit([]);
        this.selectedNames.emit([]);
        this.selectedItemDetails.emit([]);
      }
    });
  }  

  onSelectionChange() {
    const selected = this.control.value;
    if (selected && selected.includes('All')) {  // Agregado el chequeo de null
      const filtered = selected.filter(item => item !== 'All');
      this.control.setValue(filtered);
    }
  }

  toggleSelectAll() {
    this.allSelected = !this.allSelected;
    if (this.allSelected) {
      this.control.setValue([...this.items.map(item => item.id), 'All']);
    } else {
      this.control.reset();
    }
  }


  ngOnDestroy() {
    // Limpiar las selecciones cuando el componente se destruye
    this.selectedItems.emit([]);
    this.selectedNames.emit([]);
    this.selectedItemDetails.emit([]);
  }

  

}
